import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Lens = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M14.353 4.708H5.885V4.04h8.468v.667Z" />
      <path d="m4.056 8.207-.577-.333L7.712.541l.578.333-4.234 7.333Z" />
      <path d="M5.596 11.873 1.36 4.54l.578-.333 4.233 7.333-.576.333Z" />
      <path d="M10.118 12.042h-8.47v-.667h8.47v.667Z" />
      <path d="m8.29 15.543-.577-.333 4.235-7.335.577.333-4.235 7.335Z" />
      <path d="M14.064 11.877 9.83 4.544l.577-.333 4.234 7.333-.577.333Z" />
      <path d="M8.001.375a7.664 7.664 0 1 1-.737 15.294A7.667 7.667 0 0 1 5.017.978c.944-.4 1.96-.605 2.984-.603Zm0 14.666a7.002 7.002 0 0 0 2.725-13.45 7.002 7.002 0 0 0-5.45 12.9 6.956 6.956 0 0 0 2.725.55Z" />
    </svg>
  );
};

Lens.category = 'product-category';

Lens.displayName = 'Lens';
